export default __webpack_public_path__ + "static/media/2019-6.1a14bca5.jpeg";